import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import socket from '@/socket/socket';
import { updateStateOnUpdateAccountById, updateStateOnAddAccountById, updateStateOnDeleteAccountById } from '@/redux/actions';

export const useAccountRealtime = ({ customerId, }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!customerId) {
            return;
        }

        const handleAccountChanged = ({ id, action }) => {
            console.log('<<<Account changed:', id, customerId, action);

            if (action === 'UPDATE') {
                dispatch(updateStateOnUpdateAccountById(id));
            } else if (action === 'CREATE') {
                dispatch(updateStateOnAddAccountById(id));
            } else if (action === 'DELETE') {
                dispatch(updateStateOnDeleteAccountById(id));
            }
        };

        socket.on('account:changed', handleAccountChanged);

        return () => {
            socket.off(
                'account:changed',
                handleAccountChanged
            );
        };

    }, [customerId, dispatch]);
};